<template>
  <div style="background: #ffffff">
    <div class="hidden-sm-and-up mobile-overview">
      <div class="overview-title" style="height: 50px">总览</div>
      <DataCard
        :title="this.titles[0]"
        :value="this.data.userCount"
        :subtitle="
          '今日注册数：' +
          (this.data.today.signUpCount === undefined
            ? '-'
            : this.data.today.signUpCount)
        "
      />
      <br />
      <OrderCard
        :title="this.titles[1]"
        :value="this.data.todayPaidOrderCount + '/' + this.data.todayOrderCount"
        :wechat="
          this.data.paymentMethod.wechat.paidCount +
          '/' +
          this.data.paymentMethod.wechat.count
        "
        :alipay="
          this.data.paymentMethod.alipay.paidCount +
          '/' +
          this.data.paymentMethod.alipay.count
        "
        :appStore="
          this.data.paymentMethod.appStore.paidCount +
          '/' +
          this.data.paymentMethod.appStore.count
        "
      />
      <br />
      <DataCard
        :title="this.titles[2]"
        :value="
          '¥' +
          (this.data.todayOrderTotal === '-'
            ? '-'
            : this.data.todayOrderTotal / 100)
        "
        :subtitle="'昨日金额：¥' + this.data.yesterday.orderTotal"
      />
      <br />
      <DataCard
        :title="this.titles[3]"
        :value="this.data.itemCount"
        :subtitle="'今日添加数量：' + this.data.today.itemCount"
      />
      <br />
    </div>
    <div class="bg-success hidden-sm-and-down">
      <div class="card">
        <a-row type="flex" justify="space-between">
          <a-col :span="5">
            <DataCard
              :title="this.titles[0]"
              :value="this.data.userCount"
              :subtitle="
                '今日注册数：' +
                (this.data.today.signUpCount === undefined
                  ? '-'
                  : this.data.today.signUpCount)
              "
            />
          </a-col>
          <a-col :span="5">
            <OrderCard
              :title="this.titles[1]"
              :value="
                this.data.todayPaidOrderCount + '/' + this.data.todayOrderCount
              "
              :wechat="
                this.data.paymentMethod.wechat.paidCount +
                '/' +
                this.data.paymentMethod.wechat.count
              "
              :alipay="
                this.data.paymentMethod.alipay.paidCount +
                '/' +
                this.data.paymentMethod.alipay.count
              "
              :appStore="
                this.data.paymentMethod.appStore.paidCount +
                '/' +
                this.data.paymentMethod.appStore.count
              "
            />
          </a-col>
          <a-col :span="5">
            <DataCard
              :title="this.titles[2]"
              :value="
                '¥' +
                (this.data.todayOrderTotal === '-'
                  ? '-'
                  : this.data.todayOrderTotal / 100)
              "
              :subtitle="'昨日金额：¥' + this.data.yesterday.orderTotal"
            />
          </a-col>
          <a-col :span="5">
            <DataCard
              :title="this.titles[3]"
              :value="this.data.itemCount"
              :subtitle="'今日添加数量：' + this.data.today.itemCount"
            />
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="hidden-sm-and-down">
      <a-row>
        <a-col :span="12">
          <ve-line :data="chartData"></ve-line>
        </a-col>
        <a-col :span="12">
          <a-row :gutter="[16, 16]">
            <a-col :span="12">
              <DataCard
                class="month-view-card"
                title="本月收入"
                :value="this.data.month.orderTotal"
                :subtitle="
                  'App Store:' +
                  `${this.data.month.appStoreOrderTotal}` +
                  ' / ' +
                  `${this.data.month.appStoreOrderTotal * 0.85}` +
                  '\n Non-App Store:' +
                  `${
                    this.data.month.orderTotal -
                    this.data.month.appStoreOrderTotal
                  }`
                "
              />
            </a-col>
            <a-col :span="12">
              <DataCard
                class="month-view-card"
                title="当前会员数量"
                :value="this.data.membership.available"
              />
            </a-col>
            <a-col :span="12">
              <DataCard
                class="month-view-card"
                title="已过期会员数量"
                :value="this.data.membership.expired"
              />
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
    <div class="hidden-sm-and-up mobile-overview">
      <ve-line :data="chartData"></ve-line>
      <DataCard
        class="month-view-card"
        title="本月收入"
        :value="this.data.month.orderTotal"
        :subtitle="
          'App Store:' +
          `${this.data.month.appStoreOrderTotal}` +
          ' / ' +
          `${this.data.month.appStoreOrderTotal * 0.85}` +
          '\n Non-App Store:' +
          `${this.data.month.orderTotal - this.data.month.appStoreOrderTotal}`
        "
      />
      <br />
      <DataCard
        class="month-view-card"
        title="当前会员数量"
        :value="this.data.membership.available"
      />
      <br />
      <DataCard
        class="month-view-card"
        title="已过期会员数量"
        :value="this.data.membership.expired"
      />
      <br />
    </div>
  </div>
</template>

<script>
import DataCard from "../../components/DataCard";
import OrderCard from "../../components/OrderCard";
const AV = require("leancloud-storage");

export default {
  components: {
    DataCard,
    OrderCard,
  },
  data() {
    return {
      chartData: {
        columns: ["日期", "访问用户", "下单用户", "下单率"],
        rows: [
          { 日期: "1/1", 访问用户: 1393, 下单用户: 1093, 下单率: 0.32 },
          { 日期: "1/2", 访问用户: 3530, 下单用户: 3230, 下单率: 0.26 },
          { 日期: "1/3", 访问用户: 2923, 下单用户: 2623, 下单率: 0.76 },
          { 日期: "1/4", 访问用户: 1723, 下单用户: 1423, 下单率: 0.49 },
          { 日期: "1/5", 访问用户: 3792, 下单用户: 3492, 下单率: 0.323 },
          { 日期: "1/6", 访问用户: 4593, 下单用户: 4293, 下单率: 0.78 },
        ],
      },
      data: {
        userCount: "-",
        todayPaidOrderCount: "-",
        todayOrderCount: "-",
        todayOrderTotal: "-",
        itemCount: "-",
      },
      titles: ["注册用户", "今日订单", "订单金额", "物品数量"],
    };
  },
  mounted() {
    this.asyncData();
  },
  methods: {
    async asyncData() {
      const result = await AV.Cloud.run("fetchDashboard");
      this.data = result;
      this.chartData = result.userChart;
    },
  },
};
</script>

<style>
.card {
  position: absolute;
  left: 30px;
  top: 80px;
  right: 30px;
}
.bg-success {
  /* background-color: #2dce89; */
  background: linear-gradient(to bottom, #2dce89 55%, white 45%);

  box-sizing: border-box;
  position: relative;
  width: max-w-0;
  height: 240px;
}
.mobile-overview {
  margin-left: 12px;
  margin-right: 12px;
}
.overview-title {
  background: #ffffff;
  font-size: 20px;
  padding-top: 15px;
}
</style>